import { Box, Tooltip, Typography } from '@mui/material';
import { SiniestroVisitaApi } from '../../Visitas/consts/types';

interface Props {
    siniestro?: SiniestroVisitaApi | null;
}

function buildDireccionDisplay(siniestro?: SiniestroVisitaApi | null): string {
    const lugar = siniestro?.lugarOcurrencia;
    if (!lugar) return '-';

    const partes = [
        [lugar.calle, lugar.altura].filter(Boolean).join(' '),
        lugar.localidad?.nombre,
        lugar.localidad?.provincia?.nombre
    ].filter(Boolean);

    return partes.join(', ') || '-';
}

function LugarOcurrenciaCell({ siniestro }: Props) {
    const displayText = buildDireccionDisplay(siniestro);
    const empleado = siniestro?.empleado;
    const nombreCompleto = empleado?.nombreCompleto ?? '-';
    const cuil = empleado?.cuil ?? '-';
    const nroRoam = siniestro?.nroRoam ?? '-';

    return (
        <Tooltip
            enterDelay={200}
            arrow
            title={
                <Box sx={{ minWidth: 260 }}>
                    <Typography variant="body2" sx={{ color: '#fff' }}>
                        <strong>Empleado:</strong> {nombreCompleto} — <strong>CUIL:</strong> {cuil}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#fff', mt: 0.5 }}>
                        <strong>Nro ROAM:</strong> {nroRoam}
                    </Typography>
                </Box>
            }
        >
            <Box
                component="span"
                sx={{ display: 'flex', alignItems: 'center', cursor: 'help', width: '100%', minHeight: 32 }}
            >
                {displayText}
            </Box>
        </Tooltip>
    );
}

export default LugarOcurrenciaCell;
